import request from '@/utils/request'
// 学习活动管理
const url = '/api/lottery.Wx/'
/**
 * 活动信息
 * @param {array} params 请求参数
 */
export function reqLotteryInfo(params) {
    return request({
        url: url + 'info',
        method: 'get',
        params: params
    })
}

/**
 * 幸运网友列表
 * @param {array} params 请求参数
 */
export function reqLuckUsers(params) {
    return request({
        url: url + 'luckList',
        method: 'get',
        params: params
    })
}

/**
 * 幸运网友列表
 * @param {array} params 请求参数
 */
export function reqLuckyXuan(params) {
    return request({
        url: url + 'luckListXuan',
        method: 'get',
        params: params
    })
}

/**
 * 幸运网友列表
 * @param {array} params 请求参数
 */
export function reqLuckyPhone(params) {
    return request({
        url: url + 'luckListPhone',
        method: 'get',
        params: params
    })
}

/**
 * 幸运网友列表
 * @param {array} params 请求参数
 */
export function reqTodayTimes(params) {
    return request({
        url: url + 'todayTimes',
        method: 'get',
        params: params
    })
}

/**
 * 抽奖
 * @param {array} params 请求参数
 */
export function reqGo(params) {
    return request({
        url: url + 'draw',
        method: 'get',
        params: params
    })
}

/**
 * 我的奖品
 * @param {array} params 请求参数
 */
export function reqMyprize(params) {
    return request({
        url: url + 'myPrizes',
        method: 'get',
        params: params
    })
}

/**
 * 领取奖品
 * @param {array} params 请求参数
 */
export function reqSubMyinfo(params) {
    return request({
        url: url + 'subMyinfo',
        method: 'get',
        params: params
    })
}


